import { Dialog } from '@m/alchemy-ui/Dialog';
import { WarningIcon } from '@m/alchemy-ui/icons/WarningIcon';

export function DisconnectSnappyConfirmationDialog({
  isOpen,
  onDismiss,
  onAccept,
}) {
  if (!isOpen) return null;

  return (
    <Dialog
      isOpen
      isCentered
      hasCloseIcon
      size="medium"
      headerContent={<h1>Disconnect with Snappy</h1>}
      bodyContent={
        <p>
          Are you sure you want to disconnect your Snappy account? You will
          automatically use Agent Connect Rewards again.
        </p>
      }
      footerButtons={[
        { label: 'Cancel', onClick: onDismiss },
        { label: 'Disconnect', onClick: onAccept },
      ]}
      icon={
        <WarningIcon
          palette="expressiveInformative"
          color="base"
          aria-hidden="true"
        />
      }
    />
  );
}
